import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

const FadeInContainer = ({
  direction = 'up',
  sectionGuid = '',
  shouldSearchForContent = false,
  children
}) => {
  const container = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const { current } = container;
    if (!shouldSearchForContent || !current) return;

    const content = document.getElementById(sectionGuid);
    if (content) {
      current.innerHTML = content.innerHTML;
      content.parentNode.removeChild(content);
    }
  }, [shouldSearchForContent, sectionGuid]);

  useEffect(() => {
    const { current } = container;

    if (!current) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setIsVisible((prev) => prev || entry.isIntersecting));
    });
    observer.observe(current);

    return () => observer.unobserve(current);
  }, []);

  return (
    <div
      className={clsx(`fade-in-container fade-${direction}`, { invisible: !isVisible })}
      ref={container}
    >
      {children}
    </div>
  );
};

export default FadeInContainer;
